import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/Layout"
import Metas from "../components/Metas"
import Pagination from "../components/Pagination"
import Title from "../components/Title"
import PublicationListItem from "../components/ListItems/PublicationListItem"
import CustomBreadcrumb from "../components/CustomBreadcrumb"

const PublicationList = ({ pageContext, data, location }) => {
  const {
    breadcrumb: { crumbs },
    currentPage,
    numPages,
    basePath,
  } = pageContext

  return (
    <Layout>
      <Metas title="Publications" />
      <section className="section page-breadcrumb is-small has-background-light">
        <div className="container">
          <CustomBreadcrumb crumbs={crumbs} />
        </div>
      </section>
      <section className="section page-content">
        <div className="container">
          <Title title="Publications" className="has-text-centered" />

          {pageContext.types && (
            <div className="publication-types has-text-centered">
              <h2 className="title is-6 is-uppercase">Filtrer par type</h2>
              <div className="tags is-centered">
                {pageContext.types.map((type, index) => (
                  <span
                    key={index}
                    className="tag is-rounded theme theme-green"
                  >
                    <Link to={`/publications${type.path}`}>{type.name}</Link>
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="columns is-multiline">
            {data.publications.nodes.map((node, index) => (
              <div key={index} className="column is-6 is-4-desktop publication">
                <PublicationListItem content={node} />
              </div>
            ))}
          </div>

          <Pagination
            path={location.pathname}
            currentPage={currentPage}
            numPages={numPages}
            basePath={basePath}
          />
        </div>
      </section>
    </Layout>
  )
}

export default PublicationList

export const query = graphql`
  query publicationListQuery($skip: Int!, $limit: Int!) {
    publications: allNodePublication(
      sort: { fields: created, order: DESC }
      filter: { status: { eq: true } }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        title
        relationships {
          image: field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 335
                  height: 473
                  quality: 100
                  transformOptions: { cropFocus: CENTER }
                  layout: CONSTRAINED
                )
              }
            }
          }
          file: field_fichier {
            localFile {
              publicURL
              prettySize
            }
          }
        }
      }
    }
  }
`
